<template>
  <!-- 商品的基础信息【名称】【描述】 -->
  <div class="base-info" :style="(customStyle && customStyle.root) || {}">
    <!-- 2行名称 -->
    <template v-if="nameMultiLine">
      <div class="name-wrapper-multi">
        <!-- 名称前标签 -->
        <div v-if="skuAttrTags.length > 0" class="attr-wrapper">
          <Tag
            v-for="(tag, index) in skuAttrTags"
            :key="'tag' + index"
            :has-border="!!tag.frameColor"
            :has-background="!!tag.backgroundColor"
            :primary-color="tag.textColor"
            :secondary-color="tag.frameColor"
            :corner-radius="tag.cornerRadius"
            :bg-color="tag.backgroundColor"
            :use-trans-scale="false"
            :font-size="tag.textSize"
            :bold="!!tag.bold"
            no-bottom-margin
            :padding-left-right="3"
          >
            {{ tag.tag }}
          </Tag>
        </div>
        <span class="name">
          {{ name }}<span v-if="showNameFormatInfo"> {{ formatInfo }}</span>
        </span>
      </div>
    </template>
    <!-- 1行名称 -->
    <template v-else>
      <div
        class="name-wrapper"
        :style="(customStyle && customStyle.name) || {}"
      >
        <!-- 名称前标签 -->
        <div v-if="skuAttrTags.length > 0" class="attr-wrapper">
          <Tag
            v-for="(tag, index) in skuAttrTags"
            :key="'tag' + index"
            :has-border="!!tag.frameColor"
            :has-background="!!tag.backgroundColor"
            :primary-color="tag.textColor"
            :secondary-color="tag.frameColor"
            :corner-radius="tag.cornerRadius"
            :bg-color="tag.backgroundColor"
            :use-trans-scale="false"
            :font-size="tag.textSize"
            no-bottom-margin
            :padding-left-right="4"
          >
            {{ tag.tag }}
          </Tag>
        </div>
        <!-- 名称+箱规 -->
        <div class="name">
          {{ name }}<span v-if="showNameFormatInfo"> {{ formatInfo }}</span>
        </div>
      </div>
    </template>

    <!-- 2*N 3*N 包规 箱规 -->
    <div
      v-if="!showNameFormatInfo"
      class="format-info"
      :style="(customStyle && customStyle.format) || {}"
    >
      <span v-if="formatInfo" class="format-info-text"> {{ formatInfo }}</span>
      <span v-if="ssuFpText" class="ssu-fp-text">
        {{ ssuFpText }}
      </span>
    </div>

    <div v-if="introduceTags.length > 0" class="sku-introduce">
      <template v-for="(tag, index) in introduceTags">
        <Tag
          :key="'tag' + index"
          :has-border="!!tag.frameColor"
          :has-background="!!tag.backgroundColor"
          :primary-color="tag.textColor"
          :secondary-color="tag.frameColor"
          :corner-radius="tag.cornerRadius"
          :bg-color="tag.backgroundColor"
          :has-margin="false"
          :use-trans-scale="false"
          :font-size="tag.textSize"
          no-bottom-margin
        >
          {{ tag.tag }}
        </Tag>
        <span
          v-if="index !== introduceTags.length - 1"
          :key="'line' + index"
          class="introduce-line"
          >|</span
        >
      </template>
    </div>
    <template v-if="priceRecommendTag">
      <Tag
        :primary-color="'#B98132'"
        :corner-radius="priceRecommendTag.cornerRadius"
        :use-trans-scale="false"
        :font-size="priceRecommendTag.textSize"
        :tag-style="{ display: 'inline-block', marginTop: '.04rem' }"
      >
        {{ priceRecommendTag.tag }}
      </Tag>
    </template>
    <template v-if="priceSaveTag">
      <price-tag
        :tag="priceSaveTag"
        :tag-style="{ marginTop: '.12rem' }"
      ></price-tag>
    </template>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
import PriceTag from '../widgets/price-tag.vue'

export default {
  components: {
    Tag,
    PriceTag
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    showNameFormatInfo: {
      type: Boolean,
      default: false
    },
    formatInfo: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    showSelfTag: {
      type: Boolean,
      default: false
    },
    nameMultiLine: {
      type: Boolean,
      default: false
    },
    ssuFpText: {
      type: String,
      default: ''
    },
    introduceTags: {
      type: Array,
      default: () => []
    },
    skuAttrTags: {
      type: Array,
      default: () => []
    },
    priceRecommendTag: {
      type: Object,
      default: () => null
    },
    priceSaveTag: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style lang="scss" scoped>
.name-wrapper {
  height: 0.36rem;
  margin-top: 0.08rem;

  line-height: 0.36rem;
  @include flex-row-center-column-normal;
  .attr-wrapper {
    display: flex;

    flex: none;
  }
  .name {
    font-size: 0.28rem;
    font-weight: bold;
    color: #303030;
    @include text-overflow-ellipsis-single;
  }
}
.name-wrapper-multi {
  @include text-overflow-ellipsis-multiple;
  .attr-wrapper {
    display: inline-flex;
    vertical-align: middle;
  }
  .name {
    @include text(0.28rem, #262626, true);
    vertical-align: top;
    line-height: 18px;
  }
}
.self-name {
  font-weight: bold;
  color: #262626;
  .self-support-tag {
    margin-right: 0.08rem;
    padding: 0 0.04rem;

    border-radius: 0.04rem;

    border: 0.02rem solid #8bddad;

    font-size: 0.2rem;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;

    color: #15bb5c;
  }
  .self-support-name {
    vertical-align: middle;
  }
}
.format-info {
  height: 0.3rem;

  margin-top: 0.04rem;

  font-size: 0.24rem;
  line-height: 0.3rem;
  color: #8c8c8c;
  @include text-overflow-ellipsis-single;
}
.ssu-fp-tex {
  display: inline-block;

  margin-left: 0.04rem;

  padding: 0 0.08rem;

  background-color: #f5f5f5;

  border-radius: 0.08rem;

  text-align: center;

  vertical-align: middle;

  @include text(0.2rem, #262626);
}

.sku-introduce {
  position: relative;

  margin-top: 0.08rem;

  overflow: hidden;
  @include flex-row;
  .introduce-line {
    margin-right: 4px;

    font-size: 0.24rem;
    color: #d9d9d9;
  }
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    width: 0.26rem;

    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      #fff 100%
    );

    content: '';
  }
}
.sku-feedback {
  position: relative;

  margin-top: 0.08rem;

  overflow: hidden;

  @include flex-row;
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    width: 0.72rem;

    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      #fff 100%
    );

    content: '';
  }
}
.format-info-text {
  margin-right: 0.04rem;
}

.ssu-fp-text {
  padding: 0 0.08rem;

  background-color: #f5f5f5;

  border-radius: 0.08rem;

  text-align: center;

  vertical-align: middle;

  @include text(0.2rem, #262626);
}
</style>
